<template>
  <div
    class="uploading-file-progress rounded d-flex w-full px-2 py-1 justify-content-bewteen align-items-center"
  >
    <div class="d-flex flex-column flex-fill">
      <div class="d-flex justify-content-between progress-text-wrapper">
        <span>Uploading ({{ files }}) files...</span>
        <span> Progress {{ progress.toFixed(2) }}% </span>
      </div>
      <b-progress :value="progress" />
      <div
        v-if="showPath"
        class="location"
      >
        in
        <a
          class="link"
          @click="openDestination"
        >{{ path }}</a>
        <span v-if="differentProjects"> - {{ projectName }} </span>
      </div>
    </div>
    <b-button
      variant="bg-white"
      size="sm"
      class="mr-0 ml-1 h-auto w-auto cancel-button"
      @click="$emit('cancel')"
    >
      <GjIcon name="Close" />
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'UploadProgress',
  props: {
    files: {
      type: Number,
      required: true,
      default: 0,
    },
    index: {
      type: Number,
      required: true,
    },
    showPath: {
      type: Boolean,
      default: false,
    },
    bucketName: {
      type: String,
      default: '',
    },
    uploadPath: {
      type: String,
      default: '',
    },
    projectId: {
      type: String,
      default: '',
    },
    projectName: {
      type: String,
      default: '',
    },
  },
  computed: {
    progress() {
      if (this.items) {
        let totalProgress = 0
        let totalSize = 0
        this.requestFiles[this.index].uploadData.files.forEach(file => {
          totalProgress += parseFloat(file.progress)
          totalSize += parseFloat(file.size)
        })
        return (totalProgress * 100) / totalSize
      }
      return 0.0
    },
    requestFiles() {
      return this.$store.state.uploading.requestFiles
    },
    items() {
      return this.requestFiles[this.index]
        ? this.requestFiles[this.index].uploadData.files
        : null
    },
    currentProjectId() {
      return this.$store.state.app.projectId
    },
    differentProjects() {
      return this.projectId !== this.currentProjectId
    },
    path() {
      const uploadPath = this.uploadPath ? `/${this.uploadPath}` : ''
      return `${this.bucketName}${uploadPath}`
    },
  },
  methods: {
    openDestination() {
      this.$store.commit('uploading/SET_LOADING', true)
      if (this.differentProjects) {
        this.$store.commit('app/SET_PROJECT_ID', null)
        this.$store.commit('RESET_STATE')
      }
      this.$router
        .push({
          name: 'object-files',
          params: {
            projectId: this.projectId,
            id: this.bucketName,
          },
          query: { key: this.uploadPath },
        })
        .finally(() => {
          this.$store.commit('uploading/SET_LOADING', false)
        })
      this.$emit('hide')
    },
  },
}
</script>

<style lang="scss" scoped>
.uploading-file-progress {
  background-color: #f1f6fe;
  .cancel-button {
    padding: 4px;
    color: #000 !important;
  }
  .progress-text-wrapper {
    margin-bottom: 8px;
  }
  .location {
    margin-top: 5px;
    font-size: smaller;
  }
}
</style>
